<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Grid View" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row g-4 mb-3">
    <div class="col-sm">
        <div>
            <a href="javascript:void(0);" class="btn btn-success"><i class="ri-add-line align-bottom me-1"></i> Add
                Candidate</a>
        </div>
    </div>
    <div class="col-sm-auto">
        <div class="d-md-flex justify-content-sm-end gap-2">
            <div class="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                <input type="text" class="form-control" id="searchJob" placeholder="Search for candidate name or designation..." autocomplete="off" [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                <i class="ri-search-line search-icon"></i>
            </div>

            <select class="form-control w-md" data-choices data-choices-search-false>
                <option value="All">All</option>
                <option value="Today">Today</option>
                <option value="Yesterday" selected>Yesterday</option>
                <option value="Last 7 Days">Last 7 Days</option>
                <option value="Last 30 Days">Last 30 Days</option>
                <option value="This Month">This Month</option>
                <option value="Last Year">Last Year</option>
            </select>
        </div>
    </div>
</div>

<div class="row job-list-row" id="candidate-list">
    @for ( grid of gridview; track $index) {
    <div class="col-xxl-3 col-md-6">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                        <div class="avatar-lg rounded"><img src="{{grid.img}}" alt="" class="member-img img-fluid d-block rounded"></div>
                    </div>

                    <div class="flex-grow-1 ms-3"> <a routerLink="/pages/profile">
                            <h5 class="fs-16 mb-1">{{grid.name}}</h5>
                        </a>
                        <p class="text-muted mb-2">{{grid.designation}}</p>
                        <div class="d-flex flex-wrap gap-2 align-items-center">
                            <div class="badge text-bg-success"><i class="mdi mdi-star me-1"></i>{{grid.rating}}</div>
                            <div class="text-muted">{{grid.ratingCount}} Ratings</div>
                        </div>
                        <div class="d-flex gap-4 mt-2 text-muted">
                            <div> <i class="ri-map-pin-2-line text-primary me-1 align-bottom float-start"></i>
                                {{grid.location}}
                            </div>
                            <div> <i class="ri-time-line text-primary me-1 align-bottom"></i>
                                <span class="badge" [ngClass]="{'bg-danger-subtle text-danger': grid.type == 'Part Time' ,
                                    'bg-success-subtle text-success': grid.type == 'Full Time',
                                    'bg-secondary-subtle text-secondary': grid.type == 'Freelancer' }">{{grid.type}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    <!-- pagination -->
    <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="allgridList?.length" [(page)]="service.page" [pageSize]="service.pageSize" aria-label="Custom pagination" (pageChange)="changePage()">
        <ng-template ngbPaginationPrevious let-page let-pages="pages">
            <i class="ci-arrow-left me-2"></i>
            Prev
        </ng-template>
        <ng-template ngbPaginationNext>
            Next
            <i class="ci-arrow-right ms-2"></i>
        </ng-template>
    </ngb-pagination>

    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>